import "./event_graph.js";

class MetricGraph {
  constructor(manager) {
    this.hideDelay = 3000;
    this.manager = manager;
    this.eventGraph = new EventGraph(this.manager);
    this.parseDate = d3.timeParse("%Y-%m-%d"); // parse the date / time
    this.color = d3.scaleOrdinal(["#5aadca", "#cb5990", "#6ec28c", "#db6709"]);
    this.numberOfYTicks = 4;
    // set the dimensions and margins of the graph
    this.margin = { top: 20, right: 0, bottom: 75, left: 0 };
    this.height = 450 - this.margin.top - this.margin.bottom;
    this.clearHideIntervalOnEvent();
    this.init();
    this.legend = jQuery("<div>", { class: "legend" });
    this.seriesData = new Map(); // A store of metadata about the series in the current data key = series name, value = metadata
    this.showTotals = true;
  }

  init() {
    this.graphContainer = jQuery('<div class="report-graph-container"></div>');
    this.manager.$container.append(this.graphContainer);
  }

  render(metricType) {
    this.metricType = metricType;
    this.previousAnchors = false;

    this.hideInterval = false;
    this.manager.$container.find(".report-table-container").hide();

    d3.csv(this.manager.url("metric_graph.csv"), (error, data) => {
      if (error) {
        this.manager.$container.trigger("dataError:empty", { type: "graph", reason: "server" });
        throw error;
      }
      this.data = data;
      this.updateSeriesData(data);
      data.forEach((d) => {
        d.date = this.parseDate(d.date);
        d.value = +d.value; // Coerce to a number
      });
      this.renderLegend();
      this.renderChart();
    });
  }

  updateSeriesData(data) {
    this.seriesData.clear();
    data.forEach((d) => {
      if (!this.seriesData.has(d.series)) {
        this.seriesData.set(d.series, { index: this.seriesData.size, name: d.name });
      }
    });
  }

  calculateTotals(data) {
    var total = {};
    var returnData = [];

    for (var row in data) {
      if (data[row].date != null) {
        var parsedDate = data[row].date;
        if (!total[parsedDate]) {
          total[parsedDate] = 0;
        }

        total[parsedDate] += parseInt(data[row].value);
      }
    }

    jQuery.each(total, function (key, value) {
      returnData.push({ date: new Date(key), value: value, series: "total", tooltip: "", candidate: "total" });
    });
    returnData["columns"] = data.columns;
    return returnData;
  }

  // append the svg object to the body of the page
  // appends a 'group' element to 'svg'
  // moves the 'group' element to the top left margin
  buildSVG(width, height, margin) {
    return d3
      .select(this.graphContainer.get(0))
      .append("svg")
      .attr("class", "reports-graph")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("class", "report-group")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
  }

  line(x, y) {
    return d3
      .line()
      .x(function (d) {
        return x(d.date);
      })
      .y(function (d) {
        return y(d.value);
      })
      .curve(d3.curveMonotoneX);
  }

  area(x, y, height) {
    return d3
      .area()
      .x(function (d) {
        return x(d.date);
      })
      .y1(height)
      .y0(function (d) {
        return y(d.value);
      })
      .curve(d3.curveMonotoneX);
  }

  nest(data) {
    return d3
      .nest()
      .key(function (d) {
        return d.series;
      })
      .entries(data);
  }

  yAxis(y, width) {
    var graphType = this.yAxisFormat();

    return d3
      .axisLeft(y)
      .ticks(this.numberOfYTicks)
      .tickPadding(8)
      .tickFormat((d) => {
        return graphType(d);
      });
  }

  makeYGridLines(y, svg) {
    svg
      .append("g")
      .attr("class", "grid")
      .call(d3.axisLeft(y).ticks(this.numberOfYTicks).tickSize(-this.width).tickFormat(""));
  }

  xAxis(x, dateRange) {
    var dateTick = this.xTickFormat(dateRange); // add the X Axis

    return d3.axisBottom(x).ticks(dateTick.number).tickSize(0).tickPadding(10).tickFormat(dateTick.format);
  }

  xTickFormat(dateRange) {
    // Show month or month and day depending on scale
    var oneDay = 24 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds
    var dateDiff = dateRange[1].getTime() - dateRange[0].getTime();
    var maxDaysToShow = 15;
    var tick = {};
    if (dateDiff > oneDay * 30) {
      tick.number = d3.timeMonth.every(1);
      tick.format = d3.timeFormat("%b");
    } else {
      var dayOffset = this.data.length >= maxDaysToShow ? 2 : 1;
      tick.number = d3.timeDay.every(dayOffset);
      tick.format = d3.timeFormat("%b %e");
    }
    return tick;
  }

  renderAxes(x, y, contentWidth, dateRange, height, svg, dataNest) {
    var yAxis = this.yAxis(y, contentWidth); // add the Y Axis
    var xAxis = this.xAxis(x, dateRange);
    var fontsize = "inherit";

    svg
      .append("g")
      .attr("class", "axis axis-y")
      .call(yAxis)
      .selectAll(".tick text")
      .attr("x", 10)
      .attr("dy", -4)
      .style("text-anchor", "start");

    svg.selectAll(".axis-y .tick line").attr("x1", 0).attr("x2", 0);

    svg
      .append("g")
      .attr("transform", "translate(10," + (height + this.axisXOffset) + ")")
      .attr("class", "axis axis-x")
      .call(xAxis)
      .style("font-size", (d) => {
        return fontsize;
      });
  }

  renderTotalValues(svg, totals, area) {
    var g = svg.append("g").attr("class", "total-group");

    g.append("path").data([totals]).attr("class", "area").style("fill", "#e9e9e9").attr("d", area);
  }

  renderValues(svg, valueline, area, dataNest, color, x, y) {
    // Loop through each symbol / key
    var self = this;
    this.alwaysShowFill = dataNest.length == 1;
    var dataGroup = svg.append("g").attr("class", "values");

    dataNest.forEach(function (d) {
      var series = d.key;
      var g = dataGroup.append("g").attr("class", series + " value-group");

      g.append("path")
        .attr("class", "line")
        .style("stroke-width", 4)
        .style("stroke", function () {
          return color(self.seriesData.get(series).index);
        })
        .attr("d", valueline(d.values));

      g.append("path")
        .attr("class", "line line-hitbox")
        .style("stroke-width", 25 + "px")
        .style("stroke", "transparent")
        .attr("d", valueline(d.values))
        .on("mouseover", function (d) {
          self.hidePrevious(g);
          self.showAnchors(g);
        })
        .on("mouseout", function (d) {
          self.setupHideInterval(g);
        });

      g.append("path")
        .data([d.values])
        .attr("fill", function () {
          return color(self.seriesData.get(series).index);
        })
        .attr("class", function () {
          if (self.alwaysShowFill) {
            return "area";
          }
          return "area hide";
        })
        .attr("d", area);

      g.selectAll("circle")
        .data(d.values)
        .enter()
        .append("circle")
        .attr("r", 6)
        .attr("cx", function (d) {
          return x(d.date);
        })
        .attr("cy", function (d) {
          return y(d.value);
        })
        .attr("class", "graph-tool-tip")
        .style("fill", function (d) {
          return color(self.seriesData.get(series).index);
        })
        .on("mouseover", function (d) {
          self.manager.tooltip.show(this, d.tooltip, "metric");
          jQuery(this).siblings(".area").removeClass("hide");
          // Move this dataset to the end to make tool tip selection easier
          var valuesContainer = this.parentNode.parentNode; // The group that holds all value groups
          var valueGroup = this.parentNode; // The group that holds this data value
          valuesContainer.appendChild(valueGroup);
        });
    });
  }

  renderLegend() {
    this.legend.empty();

    if (this.seriesData.size < 2) {
      return;
    }

    var totalToggle;
    var seriesToggles = jQuery();

    if (this.showTotals) {
      var legendEntry = this.buildLegendEntry("Total", "#e9e9e9");
      legendEntry.attr("data-enabled", true);
      legendEntry.on("click", handleToggleLegendEntry.bind(this));
      this.legend.append(legendEntry);
      totalToggle = legendEntry;
    }

    this.seriesData.forEach((data, series) => {
      var legendEntry = this.buildLegendEntry(data.name, this.color(data.index));
      legendEntry.attr("data-series", series);
      legendEntry.attr("data-enabled", true);
      legendEntry.on("click", handleToggleLegendEntry.bind(this));
      this.legend.append(legendEntry);
      seriesToggles = seriesToggles.add(legendEntry);
    });

    // EVENT HANDLERS

    function handleToggleLegendEntry(event) {
      var legendEntry = jQuery(event.currentTarget);
      var newState = legendEntry.attr("data-enabled") != "true";
      legendEntry.attr("data-enabled", newState);
      legendEntry.css("opacity", newState ? 1 : 0.5);
      this.renderChart(getEnabledSeriesNames(), getShowTotalsEnabled());
    }

    // HELPER FUNCTIONS

    function getEnabledSeriesNames() {
      return jQuery.map(seriesToggles.filter('[data-enabled="true"]'), (element) => {
        return jQuery(element).data("series").toString(); // Don't coerce numeric series names to numbers
      });
    }

    function getShowTotalsEnabled() {
      return jQuery(totalToggle).attr("data-enabled") == "true";
    }

    this.manager.$container.find(".report-graph-container").before(this.legend);
  }

  buildLegendEntry(text, color) {
    var swatchElement = jQuery("<span>", { class: "swatch" }).css({ backgroundColor: color });
    var textElement = jQuery("<span>", { class: "text" }).text(text);
    return jQuery("<span>", { class: "legend-entry", role: "button", tabindex: 0 }).append(
      swatchElement,
      " ",
      textElement,
    );
  }

  renderChart(seriesNames, showTotals) {
    var filteredData = this.data;

    if (typeof seriesNames != "undefined") {
      filteredData = this.data.filter((d) => seriesNames.indexOf(d.series) > -1);
    }

    if (typeof showTotals == "undefined") {
      showTotals = this.showTotals;
    }

    this.manager.$container.find(".report-graph-container").empty();

    // Determine chart bounds
    this.contentWidth = this.manager.$container.width();
    this.width = this.contentWidth - this.margin.left - this.margin.right;

    var showEvents = !this.manager.options.aggregate;
    var eventChartHeight = 50;
    this.axisXOffset = showEvents ? eventChartHeight : 0;

    var x = d3.scaleTime().range([0, this.width - 10]); // set the ranges
    var y = d3.scaleLinear().range([this.height, 0]); // ""
    var svg = this.buildSVG(this.width, this.height, this.margin);
    var dateRange = d3.extent(this.data, function (d) {
      return d.date;
    }); // Always calculate range using all data, not filtered data
    var totals = this.calculateTotals(this.data); // Always calculate total using all data, not filtered data
    var yExtent = showTotals ? totals : this.data; // Always calculate extents using all data, not filtered data
    yExtent = d3.extent(yExtent, function (d) {
      return d.value;
    });
    if (yExtent[1] === 0) {
      this.manager.$container.trigger("dataError:empty", { type: "graph", reason: "range" });
    }

    x.domain(dateRange); // scale the range of the data
    y.domain([0, yExtent[1]]);

    var valueline = this.line(x, y); // define the line
    var area = this.area(x, y, this.height); // define the area fill
    var dataNest = this.nest(filteredData); // define the data sets
    if (showTotals) {
      this.renderTotalValues(svg, totals, area);
    }

    if (showEvents) {
      this.eventGraph.render(this.manager.url("event_graph.csv"), svg, x, this.height);
    }

    this.makeYGridLines(y, svg);
    this.renderValues(svg, valueline, area, dataNest, this.color, x, y, totals);
    this.renderAxes(x, y, this.contentWidth, dateRange, this.height, svg, dataNest);

    this.manager.$container.find(".report-table-container").show();
  }

  clearHideIntervalOnEvent() {
    jQuery(this.manager.tooltip.tooltip.node()).on("tooltip:show", (e, graphType) => {
      if (graphType === "event") {
        clearInterval(this.hideInterval);
        this.hideInterval = false;
        if (this.previousAnchors) {
          this.hideAnchors(this.previousAnchors);
        }
      }
    });
  }

  hidePrevious(currentAnchors) {
    // If last anchors are not like the current anchors
    if (this.previousAnchors && this.previousAnchors !== currentAnchors) {
      this.hideAnchors(this.previousAnchors);
      if (!this.alwaysShowFill) {
        jQuery(this.previousAnchors.node()).children(".area").addClass("hide");
      }
      clearInterval(this.hideInterval);
    }
  }

  setupHideInterval(currentAnchors) {
    var self = this;

    clearInterval(this.hideInterval);
    this.hideInterval = setInterval(function () {
      if (self.manager.tooltip.shouldHideTooltip() && jQuery(currentAnchors.node()).filter(":hover").length === 0) {
        self.manager.tooltip.hide();
        self.hideAnchors(currentAnchors);
        if (!self.alwaysShowFill) {
          jQuery(currentAnchors.node()).children(".area").addClass("hide");
        }
        clearInterval(self.hideInterval);
        self.hideInterval = false;
      }
    }, this.hideDelay);
    this.previousAnchors = currentAnchors;
  }

  // Showing and hiding of anchors

  showAnchors(g) {
    g.selectAll("circle").transition(200).style("fill-opacity", 1).style("stroke-opacity", 1);
  }
  // Hide all anchors
  hideAnchors(g) {
    g.selectAll("circle").transition(300).style("fill-opacity", 0).style("stroke-opacity", 0);
  }

  yAxisFormat() {
    switch (this.metricType) {
      case "time":
        return this.formatTime;
      case "int":
        return this.formatNumber;
      case "percent":
        return this.formatPercent;
    }
  }

  formatTime(seconds) {
    var minutes = Math.floor(seconds / 60);
    var seconds = seconds % 60;

    return minutes + "m " + seconds + "s";
  }

  formatNumber(number) {
    if (number === 0 || !Number.isInteger(number)) {
      return "";
    } else {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }

  formatPercent(percent) {
    return Math.floor(percent * 100).toString() + "%";
  }
}

window.MetricGraph = MetricGraph;
